<!-- eslint-disable -->
<template lang="pug">
    .form__container(v-if="isAccessToForm")
        .form
            .form__title
                | {{ pageTitle }}
            form.form__body(action='javascript://', v-if="!isLoading")
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.paymentService_form_paymentService') }}
                    .form__field-body
                        cs-multiselect(
                            :class="{'is-danger': errors.has('paymentService')}",
                            :options="paymentServicesTypes"
                            :show-labels="false",
                            :allow-empty="false",
                            :multiple="false",
                            :custom-label="getPaymentServiceName"
                            placeholder=""
                            v-model="paymentService.type"
                            :searchable="false"
                            name='paymentService',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('billing.paymentService_form_paymentService')"
                        )
                        help-text(v-show="errors.has('paymentService')")
                            | {{ errors.first('paymentService') }}
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.paymentService_form_name') }}
                    .form__field-body
                        cs-input.form__input(
                            :class="{'is-danger': errors.has('name')}",
                            type='text', v-model='paymentService.name',
                            name='name',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('billing.paymentService_form_name')"
                        )
                        help-text(v-show="errors.has('name')")
                            | {{ errors.first('name') }}
                .form__field(v-if="paymentService.type === 'invoicebox'")
                    .form__label
                        | {{ $i18n.t('billing.paymentService_form_participantId') }}
                    .form__field-body
                        cs-input.form__input(
                            :class="{'is-danger': errors.has('participantId')}",
                            type='number',
                            v-model='paymentService.participantId',
                            name='participantId',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('billing.paymentService_form_participantId')"
                        )
                        help-text(v-show="errors.has('participantId')")
                            | {{ errors.first('participantId') }}
                .form__field(v-if="paymentService.type === 'invoicebox'")
                    .form__label
                        | {{ $i18n.t('billing.paymentService_form_participantIdent') }}
                    .form__field-body
                        cs-input.form__input(
                            :class="{'is-danger': errors.has('participantIdent')}",
                            type='number',
                            v-model='paymentService.participantIdent',
                            name='name',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('billing.paymentService_form_participantIdent')"
                        )
                        help-text(v-show="errors.has('participantIdent')")
                            | {{ errors.first('participantIdent') }}
                .form__field(v-if="paymentService.type === 'robokassa'")
                    .form__label
                        | {{ $i18n.t('billing.paymentService_form_login') }}
                    .form__field-body
                        cs-input.form__input(
                            :class="{'is-danger': errors.has('login')}",
                            type='text', v-model='paymentService.login',
                            name='login',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('billing.paymentService_form_login')"
                        )
                        help-text(v-show="errors.has('login')")
                            | {{ errors.first('login') }}
                .form__field
                    .form__label
                        | {{ $i18n.t('billing.paymentService_form_password') }}
                    .form__field-body
                        cs-input.form__input(
                            :class="{'is-danger': errors.has('password')}",
                            type='password', v-model='paymentService.password',
                            name='password',
                            v-validate="{required: !this.copy}",
                            :data-vv-as="$i18n.t('billing.paymentService_form_password')"
                        )
                        help-text(v-show="errors.has('password')")
                            | {{ errors.first('password') }}
                .form__field(v-if="paymentService.type === 'robokassa'")
                    .form__label
                        | {{ $i18n.t('billing.paymentService_form_password2') }}
                    .form__field-body
                        cs-input.form__input(
                            :class="{'is-danger': errors.has('password2')}",
                            type='password', v-model='paymentService.password2',
                            name='password2',
                            v-validate="{required: !this.copy}",
                            :data-vv-as="$i18n.t('billing.paymentService_form_password2')"
                        )
                        help-text(v-show="errors.has('password2')")
                            | {{ errors.first('password2') }}
                divider
                .form__field
                    .form__field-body
                        cs-button.form__button(color="blue" pattern="primary-outline" type='submit' @click="submitForm")
                            | {{ $i18n.t('homework.homework_create_save') }}
                        cs-button.form__button(color="blue" @click='$router.back()')
                            | {{ $i18n.t('common.common_button_cancel') }}
            cs-loader(v-else)
    div(v-else)
        .content-box.list
            .box-body
                .column.is-12-mobile.list-item.field-column
                    | {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import { cloneDeep } from 'lodash';
    import PaymentServicesApi from '../../../api/billing/paymentServices'

    export default {
        props: {
            copy: {
                type: Object,
                default: null,
            },
            type: {
                type: String,
                default: 'payment-services',
            },
            page: {
                type: [String, Number],
            },
            id: {
                type: [Number, String],
            }
        },
        mounted () {
            this.fetchData();
        },
        data () {
            return {
                paymentService: {
                    type: '',
                    name: '',
                    participantId: '',
                    participantIdent: '',
                    login: '',
                    password: '',
                    password2: '',
                },
                paymentServicesTypes: [
                    'robokassa',
                    'invoicebox',
                    'modulbank',
                    'yookassa',
                ],
                paymentServicesNames: {
                    robokassa: this.$i18n.t('billing.paymentService_form_robokassa'),
                    invoicebox: this.$i18n.t('billing.paymentService_form_invoicebox'),
                    modulbank: this.$i18n.t('billing.paymentService_form_modulbank'),
                    yookassa: this.$i18n.t('billing.paymentService_form_yookassa'),
                },
                isLoading: false,
            }
        },
        methods: {
            fetchData () {
                if (this.copy) {
                    this.paymentService = cloneDeep(this.copy);
                } else if (this.id) {
                    PaymentServicesApi.show(this.id)
                        .then(data => {
                            this.paymentService = data.paymentService;
                        })
                        .catch(err => {
                            this.showErrorMessage(err)
                        })
                }
            },
            showErrorMessage (err) {
                this.isLoading = false;
                if (err.data) {
                    this.$router.push({ name: 'payment-services:list' });
                    this.$toasted.error(err.message);
                }
                err = (err.response && err.response.data) ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            },
            submitForm () {
                this.$validator.validateAll()
                    .then((isValid) => {
                        if (isValid) {
                            this.isLoading = true;
                            if (this.copy) {
                                delete this.paymentService.id;
                                delete this.paymentService.updatedAt;
                                delete this.paymentService.createdAt;
                            }
                            let params = +this.id ? {id: +this.id, paymentService: this.paymentService} : this.paymentService;
                            PaymentServicesApi[+this.id ? 'update' : 'create'](params)
                                .then(() => {
                                    this.$router.push({name: 'payment-services:list'});
                                })
                                .catch(err => this.showErrorMessage(err));
                        }
                    });
            },
            getPaymentServiceName (type) {
                return this.paymentServicesNames[type];
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            pageTitle () {
                return !this.id ? this.$i18n.t('billing.billing_paymentServices_createTitle') : this.$i18n.t('billing.billing_paymentServices_updateTitle');
            },
            isAccessToForm () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        }
    }
</script>

<style scoped lang="scss">
    .form__container {
        margin: 0;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
        }
    }

    .form {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: flex-start;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            min-width: 8em;
            margin-bottom: 0;
            margin-top: 12px;
            text-align: right;
        }
        @include media($xlg) {
            width: 13em;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            justify-content: center;
        }
    }

    .form__button {
        width: fit-content;
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
